import { useCallback } from 'react';
import { CacheReloadRequest, CacheReloadResponse } from '../../../interface/cache';
import useToasts from '../../../resources/toasts/toasts-hook';
import cacheService from '../../../service/cache.service';
import CacheReloaderFormComponent from '../cache-reloader-form';

type Props = {
  getCacheData: (cache: string) => void;
  addToCacheData: (cache: CacheReloadResponse) => void;
};

export default function CacheReloaderFormContainerComponent({ getCacheData, addToCacheData }: Props) {
  const { push: pushToast } = useToasts();
  const reloadCache = useCallback(
    (request: CacheReloadRequest) => {
      cacheService
        .reloadCache(request)
        .then(response => {
          pushToast('Cache sent to reload! Should be reloaded in a minute.', 'success', 1000);
          addToCacheData(response);
        })
        .catch(error => {
          console.error(error);
          pushToast('Could not reload cache', 'error');
        });
    },
    [addToCacheData, pushToast],
  );

  return (
    <CacheReloaderFormComponent
      getCacheData={getCacheData}
      addToCacheData={addToCacheData}
      onSubmit={reloadCache}></CacheReloaderFormComponent>
  );
}
